window.onload = function(event) {
    setTimeout(function(){
      //document.querySelector('.product-template-kaching .product_gallery_nav .slider-thumbnail-0').click;
      simulateClick(document.querySelector('.product-template-kaching .product_gallery_nav .slider-thumbnail-0'));
    }, 100);
   var simulateClick = function (elem) {
  	// Create our event (with options)
  	var evt = new MouseEvent('click', {
  		bubbles: true,
  		cancelable: true,
  		view: window
  	});
  	// If cancelled, don't dispatch our event
  	var canceled = !elem.dispatchEvent(evt);
  };
};
